import { Logger } from '../lib/Logger';
export function reload() {
    try {
        window.location.reload();
    }
    catch (e) {
        Logger.error(e);
    }
}
//# sourceMappingURL=reload.js.map